export const filterUndefined = (thing) => thing !== undefined;
export const filterNull = (thing) => thing !== null;
export const filterNullish = (thing) => thing !== undefined && thing !== null;
//# sourceMappingURL=awesome-filters.js.map